import Colors from '@dynatrace/strato-design-tokens/colors';

export const FONT_BASE = 10;
export const SUFFIX_RATIO = 0.66;
export const FONT_HEIGHT_RATIO = 0.7;
export const FONT_WIDTH_RATIO = 0.95;
export const VALUE_FONT_CSS_TOKEN = '--dt-charts-single-value-font-size';
export const LABEL_FONT_CSS_TOKEN = '--dt-charts-single-value-label-font-size';
export const TREND_FONT_CSS_TOKEN = '--dt-charts-single-value-label-font-size';

export const DEFAULT_MAX_VALUE_FONT_SIZE = 240;

export const GLOBAL_VALUE_FONT_CSS_TOKEN =
  '--dt-charts-single-value-global-value-font-size';
export const GLOBAL_LABEL_FONT_CSS_TOKEN =
  '--dt-charts-single-value-global-label-font-size';
export const GLOBAL_TREND_FONT_CSS_TOKEN =
  '--dt-charts-single-value-global-trend-font-size';

// Maximum value font size, fallback to a default value if not defined
const MAX_VALUE_FONT_SIZE = `var(${GLOBAL_VALUE_FONT_CSS_TOKEN}, ${DEFAULT_MAX_VALUE_FONT_SIZE})`;
export const VALUE_FONT_SIZE = `min(var(${VALUE_FONT_CSS_TOKEN}, ${MAX_VALUE_FONT_SIZE}), ${MAX_VALUE_FONT_SIZE})`;

// Maximum label font size, fallback to value font size if shared label font size not defined. The label will never have greater font size than the value
const MAX_LABEL_FONT_SIZE = `min(var(${GLOBAL_LABEL_FONT_CSS_TOKEN}, ${VALUE_FONT_SIZE}), ${VALUE_FONT_SIZE})`;
export const LABEL_FONT_SIZE = `min(var(${LABEL_FONT_CSS_TOKEN}, ${MAX_LABEL_FONT_SIZE}), ${MAX_LABEL_FONT_SIZE})`;

// Maximum trend font size, fallback to value font size if shared trend font size not defined. The trend will never have greater font size than the value
const MAX_TREND_FONT_SIZE = `min(var(${GLOBAL_TREND_FONT_CSS_TOKEN}, ${VALUE_FONT_SIZE}), ${VALUE_FONT_SIZE})`;
export const TREND_FONT_SIZE = `min(var(${LABEL_FONT_CSS_TOKEN}, ${MAX_TREND_FONT_SIZE}), ${MAX_TREND_FONT_SIZE})`;

// TREND COLORS
export const UPWARD_ICON_DEFAULT_COLOR = Colors.Icon.Success.Default;
export const NEUTRAL_ICON_DEFAULT_COLOR = Colors.Icon.Primary.Default;
export const DOWNWARD_ICON_DEFAULT_COLOR = Colors.Icon.Critical.Default;
export const UPWARD_VALUE_DEFAULT_COLOR = Colors.Text.Success.Default;
export const NEUTRAL_VALUE_DEFAULT_COLOR = Colors.Text.Primary.Default;
export const DOWNWARD_VALUE_DEFAULT_COLOR = Colors.Text.Critical.Default;
